import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import approved from '../../../src/Assets/ApprovedImg/approved3.png';
import './Approved.css';

const Approved = () => {
    return (
        <Container>
            <Row className="align-items-center">
                <Col md={12} lg={12} sm={12} className="text-center">
                    <div className="section-title mt-5">
                        <h1>Your <span>Appointment</span> has been booked Successfully.</h1>
                    </div>
                </Col>
                <Col md={12} lg={12} sm={12}>
                    <img src={approved} alt="" className="approved-img img-fluid w-50" />
                </Col>
            </Row>
        </Container>
    );
};

export default Approved;